export default "__VITE_ASSET__TCnsGynm__"